import React from 'react';
import {Grid, Row, Col} from '@/grid';
import Container from '@/container';
import {SectionPadding} from '@/section';
import {H2, H3, P, PNoMargin} from '@/typography';
import {withBgYellow50} from '@/hocs/withColors';
import {withBoldWeight} from '@/hocs/withFontType';
import {withMarginBottomMd} from '@/hocs/withSpacing';
import PictureWrapper from '@/ui/images-wrapper';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import {useTranslations} from 'next-intl';

const imgPath = '/static/images/about/';

const SpaceMargined = withMarginBottomMd('div');

const Yellow50Section = withBgYellow50(SectionPadding);
const BoldSpan = withBoldWeight('span');

const WhoWeAre = () => {
  const t = useTranslations('about.whoWeAre');

  return (
    <Yellow50Section>
      <Container>
        <Grid fluid>
          <Row center="xs">
            <Col xs={12} lg={8}>
              <H2>{t('title')}</H2>
              <P>
                {t.rich('description', {
                  bold: chunks => <BoldSpan>{chunks}</BoldSpan>
                })}
              </P>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <GridLayout Col={3} lgCol={2} autoRows>
                <GridItem>
                  <BoxGrid backgroundColor="var(--yellow100)">
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="boston"
                      imageTypeFallback="png"
                      alt={t('offices.boston.imageAlt')}
                    />
                    <SpaceMargined />
                    <H3>{t('offices.boston.title')}</H3>
                    <PNoMargin>{t('offices.boston.address')}</PNoMargin>
                  </BoxGrid>
                </GridItem>
                <GridItem>
                  <BoxGrid backgroundColor="var(--yellow100)">
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="athens"
                      imageTypeFallback="png"
                      alt={t('offices.athens.imageAlt')}
                    />
                    <SpaceMargined />
                    <H3>{t('offices.athens.title')}</H3>
                    <PNoMargin>{t('offices.athens.address')}</PNoMargin>
                  </BoxGrid>
                </GridItem>
                <GridItem>
                  <BoxGrid backgroundColor="var(--yellow100)">
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="london"
                      imageTypeFallback="png"
                      alt={t('offices.london.imageAlt')}
                    />
                    <SpaceMargined />
                    <H3>{t('offices.london.title')}</H3>
                    <PNoMargin>{t('offices.london.address')}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              </GridLayout>
            </Col>
          </Row>
        </Grid>
      </Container>
    </Yellow50Section>
  );
};

export default WhoWeAre;
